var _g, _mask, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLowBatteryMarker = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1753_180924)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 29,
    rx: 4,
    ry: 2,
    fill: "black",
    fillOpacity: 0.12
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_1753_180924",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 1,
    width: 22,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 5,
    y: 1,
    width: 22,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9159 20.0632C24.3926 18.243 26 15.3092 26 12C26 6.47715 21.5228 2 16 2C10.4772 2 6 6.47715 6 12C6 15.3092 7.60742 18.243 10.0841 20.0632C11.9661 21.4813 14.619 23.7185 15.2288 27.3195C15.2934 27.701 15.6131 27.997 16 27.997C16.3869 27.997 16.7066 27.701 16.7712 27.3195C17.381 23.7185 20.0339 21.4813 21.9159 20.0632Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9159 20.0632C24.3926 18.243 26 15.3092 26 12C26 6.47715 21.5228 2 16 2C10.4772 2 6 6.47715 6 12C6 15.3092 7.60742 18.243 10.0841 20.0632C11.9661 21.4813 14.619 23.7185 15.2288 27.3195C15.2934 27.701 15.6131 27.997 16 27.997C16.3869 27.997 16.7066 27.701 16.7712 27.3195C17.381 23.7185 20.0339 21.4813 21.9159 20.0632Z",
    fill: "#FEC514"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9159 20.0632L21.3237 19.2573L21.3141 19.2645L21.9159 20.0632ZM10.0841 20.0632L10.6859 19.2645L10.6763 19.2574L10.0841 20.0632ZM15.2288 27.3195L14.2428 27.4865H14.2428L15.2288 27.3195ZM16.7712 27.3195L17.7572 27.4865H17.7572L16.7712 27.3195ZM22.5081 20.869C25.2301 18.8685 27 15.6409 27 12H25C25 14.9776 23.555 17.6175 21.3237 19.2574L22.5081 20.869ZM27 12C27 5.92487 22.0751 1 16 1V3C20.9706 3 25 7.02944 25 12H27ZM16 1C9.92487 1 5 5.92487 5 12H7C7 7.02944 11.0294 3 16 3V1ZM5 12C5 15.6409 6.76987 18.8685 9.49185 20.869L10.6763 19.2574C8.44496 17.6175 7 14.9776 7 12H5ZM16.2147 27.1526C15.5345 23.1359 12.5819 20.6933 10.6859 19.2645L9.48226 20.8618C11.3502 22.2694 13.7034 24.3011 14.2428 27.4865L16.2147 27.1526ZM16 26.997C16.0686 26.997 16.1251 27.0246 16.1593 27.0551C16.1912 27.0836 16.2089 27.118 16.2147 27.1526L14.2428 27.4865C14.3809 28.3017 15.0789 28.997 16 28.997V26.997ZM15.7853 27.1526C15.7911 27.118 15.8088 27.0836 15.8407 27.0551C15.8749 27.0246 15.9314 26.997 16 26.997V28.997C16.9211 28.997 17.6191 28.3017 17.7572 27.4865L15.7853 27.1526ZM21.3141 19.2645C19.4181 20.6933 16.4655 23.1359 15.7853 27.1526L17.7572 27.4865C18.2966 24.3011 20.6498 22.2694 22.5177 20.8618L21.3141 19.2645Z",
    fill: "#FAFEFF",
    fillOpacity: 0.5,
    mask: "url(#path-2-outside-1_1753_180924)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 13.1667H16.5834V9.66675H15.4167V13.1667ZM16 15.5001C16.1653 15.5001 16.3039 15.4442 16.4157 15.3324C16.5275 15.2206 16.5834 15.082 16.5834 14.9167C16.5834 14.7515 16.5275 14.6129 16.4157 14.5011C16.3039 14.3893 16.1653 14.3334 16 14.3334C15.8348 14.3334 15.6962 14.3893 15.5844 14.5011C15.4726 14.6129 15.4167 14.7515 15.4167 14.9167C15.4167 15.082 15.4726 15.2206 15.5844 15.3324C15.6962 15.4442 15.8348 15.5001 16 15.5001ZM13.6667 17.8334C13.5014 17.8334 13.3629 17.7775 13.2511 17.6657C13.1393 17.5539 13.0834 17.4154 13.0834 17.2501V7.91675C13.0834 7.75147 13.1393 7.61293 13.2511 7.50112C13.3629 7.38932 13.5014 7.33341 13.6667 7.33341H14.8334V6.16675H17.1667V7.33341H18.3334C18.4987 7.33341 18.6372 7.38932 18.749 7.50112C18.8608 7.61293 18.9167 7.75147 18.9167 7.91675V17.2501C18.9167 17.4154 18.8608 17.5539 18.749 17.6657C18.6372 17.7775 18.4987 17.8334 18.3334 17.8334H13.6667Z",
    fill: "#000405"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1753_180924",
    x: 10,
    y: 25,
    width: 12,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1753_180924"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLowBatteryMarker, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LowBatteryMarker.60df53e8.svg";
export { ForwardRef as ReactComponent };